import React from 'react'
import {Col, Container, Row} from "reactstrap";

const PricingContent = () => {
    return (
        <Container fluid>
            <Row>
                <Col>
                    <div className="text-center mb-5">
                        <h1 className="fw-bold display-3">Unlock the Perfect Plan for Your Needs</h1>
                        <h2 className="text-muted">
                            Flexible pricing plans designed to fit businesses of all sizes.
                        </h2>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export default PricingContent
